<template>
  <template-layout :breadCrumbList="breadcrumb">
    <div class="pb-12 px-2 sm:px-4 welfare-admin">
      <nav class="flex flex-col md:flex-row md:items-end justify-between gap-3 mb-4">
        <div>
          <div class="flex flex-wrap items-center gap-2">
            <h1 class="text-2xl text-dark">จัดการสวัสดิการ</h1>
            <router-link :to="{ name: 'welfare-guide' }" class="guide-badge" :class="{ 'guide-badge--active': active === 'welfare-guide' }" title="คู่มือการใช้งาน">
              <BookOpenIcon class="w-3 h-3" /> คู่มือ
            </router-link>
          </div>
          <div class="text-sm text-theme-37 mt-0.5">{{ subtitle }}</div>
        </div>
        <div class="flex flex-wrap items-center gap-2">
          <slot name="actions" />
        </div>
      </nav>

      <div class="flex flex-wrap gap-1 border-b border-gray-200 mb-5">
        <router-link
          v-for="p in pages" :key="p.name" :to="{ name: p.name }"
          class="welfare-tab" :class="{ 'welfare-tab--active': p.name === active }"
        >{{ p.label }}<span v-if="p.hint" class="welfare-tab-hint">{{ p.hint }}</span></router-link>
      </div>

      <slot />
    </div>
  </template-layout>
</template>

<script setup>
import { computed } from "vue";
import TemplateLayout from "@/layouts/top-navbar-menu/Main.vue";
import { WELFARE_PAGES } from "../constants";

const props = defineProps({
  active: { type: String, required: true },
  subtitle: { type: String, default: "" },
});
const pages = WELFARE_PAGES;
const breadcrumb = computed(() => {
  const cur = pages.find((p) => p.name === props.active);
  return [{ name: "จัดการสวัสดิการ" }, { name: cur ? cur.label : props.active === "welfare-guide" ? "คู่มือการใช้งาน" : "", active: true }];
});
</script>

<style lang="scss">
.welfare-admin {
  .guide-badge {
    display: inline-flex; align-items: center; gap: 0.25rem;
    font-size: 0.7rem; line-height: 1; padding: 0.25rem 0.55rem; border-radius: 9999px;
    color: #728096; background: #f1f5f8; border: 1px solid #e2e8f0; white-space: nowrap;
    transition: color 0.15s ease, background-color 0.15s ease;
    &:hover { color: #415A77; background: #e6edf5; }
    &--active { color: #415A77; border-color: #415A77; background: #eef1f6; }
  }
  .welfare-tab {
    padding: 0.45rem 0.9rem;
    border-bottom: 2px solid transparent;
    margin-bottom: -1px;
    color: #728096;
    font-size: 0.95rem;
    white-space: nowrap;
    transition: color 0.15s ease, border-color 0.15s ease;
    &:hover { color: #415A77; }
    &--active { color: #415A77; border-color: #415A77; font-weight: 500; }
  }
  .welfare-tab-hint { margin-left: 0.4rem; font-size: 0.68rem; font-weight: 400; color: #728096; background: #f1f5f8; border-radius: 9999px; padding: 0.05rem 0.45rem; vertical-align: middle; }
  .chip {
    display: inline-flex; align-items: center; gap: 0.25rem;
    font-size: 0.75rem; font-weight: 500; line-height: 1.2;
    padding: 0.2rem 0.6rem; border-radius: 9999px; white-space: nowrap;
  }
  .chip-outline { color: #415A77; background: #eef1f6; border: 1px solid #dce1ea; }
  .chip-muted { color: #728096; background: #f1f5f8; }
  .drag-handle { cursor: grab; color: #a0aec0; touch-action: none; }
  .drag-handle:hover { color: #415A77; }
  .drag-handle:active { cursor: grabbing; }
  .sortable-ghost { opacity: 0.35; background: #e6f0f9 !important; }
  .sortable-chosen { box-shadow: 0 6px 18px rgba(65, 90, 119, 0.25); }
  .icon-btn {
    width: 1.9rem; height: 1.9rem; border-radius: 0.375rem;
    display: inline-flex; align-items: center; justify-content: center;
    color: #fff; border: 0; padding: 0;
    &:disabled { opacity: 0.4; cursor: not-allowed; }
  }
  .icon-btn-edit { background: rgba(44, 63, 86, 0.7); &:hover { background: rgba(44, 63, 86, 0.6); } }
  .icon-btn-view { background: rgba(107, 133, 164, 0.8); &:hover { background: rgba(107, 133, 164, 0.65); } }
  .icon-btn-del { background: rgba(206, 49, 49, 0.8); &:hover { background: rgba(206, 49, 49, 0.55); } }
  .icon-btn-plain { background: #eef1f6; color: #415A77; &:hover { background: #dce1ea; } }
  .table-admin {
    th { background: #415A77; color: #fff; font-weight: 500; white-space: nowrap; }
    td { vertical-align: top; }
    tbody tr:hover { background: #f7f9fb; }
  }
  .form-label { font-size: 0.85rem; color: #4a5568; margin-bottom: 0.25rem; display: block; }
  .field-error { color: #CE3131; font-size: 0.75rem; margin-top: 0.25rem; }
  .empty-state { color: #728096; text-align: center; padding: 2.5rem 1rem; font-size: 0.95rem; }
  .clamp-3 { display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden; }
  .clamp-2 { display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }
}
</style>
